import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { useNavigate, useParams, useLocation  } from "react-router-dom";
import { TiEdit,TiDeleteOutline, TiEyeOutline } from "react-icons/ti";
import { FcPlus } from "react-icons/fc";
import { RiCheckboxMultipleBlankLine } from "react-icons/ri";
import { Container, Row, Col, Button, Stack } from 'react-bootstrap';
import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import moment from "moment";
import { toast } from "react-toastify";

import { useAuthContext } from "../../contexts/AuthContext";
import ProjectFileDataService from "../../services/projectFile.service";

import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import "./ProjectFile.scss";

const perPage = 10;

function ProjectFile() {

  let { projectId } = useParams();

  const aggridRef = useRef();

  const navigate = useNavigate();
  const { user, setIsLoading } = useAuthContext();

  const [projectFileList, setProjectFileList] = useState([]);
  const [pageSize, setPageSize] = useState();

  useEffect(() => {
    if(user){
      retrieveProjectFileDetails();
    }
  }, [user, projectId])
  

  function retrieveProjectFileDetails() {
    setIsLoading(true);
    ProjectFileDataService.getByProject(projectId).then((response) => {
      setIsLoading(false);
      setProjectFileList(response.data.data);
    });
  }

  function deleteStructure(id) {
    setIsLoading(true);
    ProjectFileDataService.delete(id).then((response) => {
      setIsLoading(false);
      if(response.data.success){
        const updatedStructure = projectFileList.filter((item) => item.id !== id);
        setProjectFileList(updatedStructure);
        toast.error("Project File Deleted!");
      } else {
        toast.error("Error in deleting Project File");
      }
    });
  }

  function onPageSizeChanged(e) {
    let value = e.target.value;
    setPageSize(value);
    aggridRef.current.api.paginationSetPageSize(Number(value));
  };

  const columnDefs = [
    // {headerName: "Project Structure File", field: "projectStructureId.structureName", filter: true, sortable:true, width:"250"},
    {headerName: "Supplier Code", field: "projectSupplierId.supplierCode",filter: true, sortable:true,width:"130"},
    {headerName: "Project File Name", field: "projectFileName",filter: true,  sortable:true,width:"350"},
    // {headerName: "File Format Name", field: "fileFormatName",filter: true,  sortable:true},
    {headerName: "Format Type", field: "fileFormat",filter: true,  sortable:true},
    {headerName: "File", field: "file_Name",filter: true,  sortable:true},
    {headerName: "Modified By", field: "modifiedBy.name",filter: true,  sortable:true, width:"120",
      cellRendererFramework: (data) => {
        return (!data.value ? "admin" :  data.value)
        } 
    },
    {headerName: "Updated At", field: "updatedAt",filter: true,  sortable:true, width:"160",
        cellRendererFramework: (data) => {
          return moment(new Date(data.value)).format("DD/MM/yyyy hh:mm:ss A")
        } 
    },
    {headerName: "Action", field:"id", width:"150",
        cellRendererFramework: (data) => {
           return <>
                <Link title="Details" className="text-primary mr-4 margin-right" to={"/project/"+projectId+"/file/"+data.value+"/detail"}><TiEyeOutline  size="25" /></Link>
                <Link title="Clone" className="text-warning mr-2 margin-right" to={"/project/"+projectId+"/file/"+data.value+"/clone"}><RiCheckboxMultipleBlankLine size="20" /></Link>
                <Link title="Edit" className="text-success mr-2 margin-right" to={"/project/"+projectId+"/file/"+data.value+"/edit"}><TiEdit  size="25" /></Link>
                {user && user?.role === "superadmin" && (
                  <span className="text-danger cursor-pointer" title="delete" onClick={() => deleteStructure(data.value)}><TiDeleteOutline size="25" /></span>
                )}
            </>
      }
    }
  ];

  return (
    <Container fluid="md">
      <Row>
        <Col sm={8}><h1 className="mt-4 pageTitle">Project File Configuration</h1></Col>
        <Col sm={4}>
          <Stack direction="horizontal" gap={1}>
            <Button variant="primary" className="mt-4" onClick={() => navigate(`/project/${projectId}/file/create`)}><FcPlus /> Create Configuration File</Button>
          </Stack>
        </Col>
      </Row>
      <hr />
      <Row>
        <Col>
          <div className="ag-theme-balham" style={{height: '567px', width: '100%'}} >
            {projectFileList && projectFileList.length > 0 ? (
              <div className="example-header">
                Page Size: &nbsp;
                <select onChange={onPageSizeChanged} id="page-size" value={pageSize}>
                  <option value="10">
                    10
                  </option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
              </div>
            ) : (
              <h6>No Project File Found</h6>
            )}
            
            {projectFileList && projectFileList.length > 0 && projectId && (
              <AgGridReact
                  ref={aggridRef}
                  pagination={true}
                  rowHeight={50}
                  paginationPageSize={perPage}
                  columnDefs={columnDefs}
                  rowData={projectFileList}>
              </AgGridReact>
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default ProjectFile;
